/** 试用功能 UI 绑定（featureKey / skuCode 与后端 trial-features 对齐） */
export const TRIAL_FEATURE_CLOUD_IRIS = 'COM_CLOUD_IRIS'
export const TRIAL_FEATURE_STORE_OPS = 'COM_STORE_OPS_PLUS'

/** 设备列表页 coffee_menu id（router DEVICE_LIST_MENU_IDS.page；须字符串，雪花 id 勿用 Number） */
export const DEVICE_LIST_MENU_ID = '1721721668100947968'
/** 设备管理一级（coffee_menu en_name=devices；侧栏祖先链可继承三角，但不扩散兄弟/子树） */
export const DEVICE_MANAGEMENT_MENU_ID = '1721413909618884608'

export const TRIAL_FEATURE_REGISTRY = {
  [TRIAL_FEATURE_CLOUD_IRIS]: {
    skuCode: TRIAL_FEATURE_CLOUD_IRIS,
    promoSku: 'DEV_CLOUD_IRIS',
    routes: [
      '/device-list-index',
      '/device/list',
      '/device-detail',
      '/device-detailautomatic'
    ],
    menuIds: [DEVICE_LIST_MENU_ID],
    menuEnNames: ['machineList'],
    /** 仅设备列表页；不标设备管理下兄弟菜单，也不标列表下子菜单 */
    inheritDescendants: false
  },
  [TRIAL_FEATURE_STORE_OPS]: {
    skuCode: TRIAL_FEATURE_STORE_OPS,
    promoSku: 'COM_STORE_OPS_PLUS',
    routes: ['/ecosystem-mall/soc-ops'],
    menuIds: [990502, 990420]
  }
}

export function trialFeatureKeyFromPromoSku (promoSku) {
  const sku = String(promoSku || '').trim()
  for (const key of Object.keys(TRIAL_FEATURE_REGISTRY)) {
    const row = TRIAL_FEATURE_REGISTRY[key]
    if (row.promoSku === sku || row.skuCode === sku) return key
  }
  return sku.indexOf('COM_') === 0 ? sku : ''
}



// WEBPACK FOOTER //
// ./src/constants/trialFeatureRegistry.js